<template>
  <div class="evaluation-list">
    <c-table
      ref="table"
      :columns="columns"
      url="/activity/list"
      @after-fetch="afterFetch"
    >
      <template slot="operate">
        <el-button type="primary" @click="$router.push(`/evaluation/edit-prize`)" v-if="permissionFn('admin')">奖项设置</el-button>
        <el-badge :value="people" type="primary" v-if="permissionFn('admin')">
          <el-button type="primary" @click="$router.push(`/evaluation/detail`)">查看候选人</el-button>
        </el-badge>
      </template>
       <el-table-column slot="name" label="奖项名称" width="200" :showOverflowTooltip="true">
        <template v-slot="{row}">
          <span :class="['name',{overflow:isSafria}]">{{row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="describe" label="奖项意义" width="600" :showOverflowTooltip="true">
        <template v-slot="{row}">
          <span :class="{overflow:isSafria}">{{row.describe}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="number" label="评选人数" minWidth="100" align="center">
        <template v-slot="{row}">
          <span>{{row.number===0?'不定':row.number}}</span>
        </template>
      </el-table-column>
    </c-table>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import mixin from '@/mixins'
import permissionMixins from '@/mixins/permission'
export default {
  mixins: [ mixin, permissionMixins ],
  components: { CTable },
  data () {
    return {
      people: 0,
      columns: [
        { slot: 'name' },
        { slot: 'describe' },
        { slot: 'number' }
      ]
    }
  },
  computed: {
    isSafria() {
      const ua = navigator.userAgent.toLowerCase()
      return ua.indexOf('safari/') > -1 && ua.indexOf('chrome/') === -1
    }
  },
  methods: {
    afterFetch(prize) {
      const prizeData = prize.data.data
      if (![2, 10].includes(prize.data.previllage) || (!(prizeData && prizeData.length))) {
        return
      }
      const prizeIds = prizeData.map(item => {
        return item.id
      })
      this.$http.post('/activity/join_list').then(res => {
        if (res.data.data && res.data.data.length) {
          this.people = res.data.data.filter(item => prizeIds.includes(item.id)).length
        }
      })
    }
  }
}
</script>

<style lang="scss">
.evaluation-list{
  .overflow{
    width:570px;
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    &.name{
      width:170px;
    }
  }
}
</style>
